export default __webpack_public_path__ + "static/media/home-open-sessions.91453ff0.svg";